import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'rootReducer'
import { authApi } from 'slices/authApi'
import { usersApi } from 'slices/usersApi'
import { productsApi } from 'slices/productsApi'
import { chatApi } from 'slices/chatApi'
import { catApi } from 'slices/catApi'
import { locationApi } from 'slices/locationApi'
import { planApi } from 'slices/planApi'
import { addOnApi } from 'slices/addOnApi'
import { blogApi } from 'slices/blogApi'
import { quizApi } from 'slices/quizApi'

import { categorySlice } from 'slices/beautyApp/categorySlice'
import { subCategorySlice } from 'slices/beautyApp/subCatSlice'
import { serviceType } from 'slices/beautyApp/serviceType'
import { packageSlice } from 'slices/beautyApp/packageSlice'
import { productSlice } from 'slices/beautyApp/productSlice'
import { shopCatSlice } from 'slices/eCommerce/shopCatSlice'
import { shopSubCat } from 'slices/eCommerce/shopSubCat'
import { brandSlice } from 'slices/eCommerce/brandSlice'
import { colorSlice } from 'slices/eCommerce/colorSlice'
import { sizeSlice } from 'slices/eCommerce/sizeSlice'
import { shopProducts } from 'slices/eCommerce/shopProducts'
import { beauticianSlice } from 'slices/beautyApp/beauticianSlice'
import { locationSlice } from 'slices/common/locationSlice'
import { timeslotSlice } from 'slices/common/timeslotSlice'
import { orderSlice } from 'slices/common/orderSlice'
import { offerSlice } from 'slices/common/offerSlice'
import { concernSlice } from 'slices/wellness/concernSlice'
import { doctorSlice } from 'slices/wellness/doctorSlice'
import { clinicSlice } from 'slices/wellness/clinicSlice'
import { staffSlice } from 'slices/staffSlice'
import { scanSlice } from 'slices/skin/scanSlice'
import { jobApply } from 'slices/beautyApp/jobApply'
import { testimonialSlice } from 'slices/cms/testimonialSlice'
import { homeSlice } from 'slices/cms/homeSlice'
import { blogSlice } from 'slices/cms/blogSlice'
import { servicePackageSlice } from 'slices/beautyApp/servicePackageSlice'
import { dashboardSlice } from 'slices/common/dashboardSlice'
import { alertSlice } from 'slices/common/alertSlice'
import { couponSlice } from 'slices/common/couponSlice'
import { addOnStockSlice } from 'slices/beautyApp/addOnStockSlice'
import { subscriptionSlice } from 'slices/beautyApp/subscriptionSlice'
import { reportIssueSlice } from 'slices/common/reportIssueSlice'

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authApi.middleware, usersApi.middleware, productsApi.middleware, chatApi.middleware, catApi.middleware, locationApi.middleware, planApi.middleware, addOnApi.middleware, blogApi.middleware, quizApi.middleware,

        categorySlice.middleware, subCategorySlice.middleware, serviceType.middleware, packageSlice.middleware, productSlice.middleware, shopCatSlice.middleware, shopSubCat.middleware, brandSlice.middleware, colorSlice.middleware, sizeSlice.middleware, shopProducts.middleware, beauticianSlice.middleware, locationSlice.middleware, timeslotSlice.middleware, orderSlice.middleware, offerSlice.middleware, concernSlice.middleware, doctorSlice.middleware, clinicSlice.middleware, staffSlice.middleware, scanSlice.middleware, jobApply.middleware, homeSlice.middleware, testimonialSlice.middleware, blogSlice.middleware, servicePackageSlice.middleware, dashboardSlice.middleware, alertSlice.middleware, couponSlice.middleware, addOnStockSlice.middleware, subscriptionSlice.middleware, reportIssueSlice.middleware)
})